// extracted by mini-css-extract-plugin
export default {"tributes__radio":"styles_tributes__radio__AuuiG"};